import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Heading from '../heading/Heading';
import ScrollingText from '../scrolling-text/ScrollingText';
import Button from '../button/Button';
import Message from '../message/Message';
import {priority} from '../../constants/';

import {formatLeadingZero} from '../../utils/GeneralUtils';
import styles from './CounterTitle.pcss';

class CounterTitle extends PureComponent {
    static propTypes = {
        primaryText: PropTypes.string.isRequired,
        secondaryText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        headingLevel: PropTypes.number,
        buttonMessageCode: PropTypes.string,
        onClick: PropTypes.func,
        className: PropTypes.string
    };

    static defaultProps = {
        headingLevel: 3
    };

    render() {
        const {
            headingLevel,
            primaryText,
            secondaryText,
            buttonMessageCode,
            onClick,
            className
        } = this.props;

        const titleClasses = cx(styles.wrapper, className);

        return (
            <span className={titleClasses}>
                <Heading className={styles.primary} level={headingLevel}>
                    {primaryText && <Message code={primaryText} />}
                </Heading>
                {typeof secondaryText !== 'undefined' && (
                    <span className={styles.secondary}>
                        <ScrollingText>{formatLeadingZero(secondaryText)}</ScrollingText>
                    </span>
                )}
                {onClick && buttonMessageCode && (
                    <span className={styles.button}>
                        <Button
                            className={styles.button}
                            onClick={onClick}
                            priority={priority.TERTIARY}>
                            {buttonMessageCode && <Message code={buttonMessageCode} />}
                        </Button>
                    </span>
                )}
            </span>
        );
    }
}

export default CounterTitle;
